<template>
  <div class="exhibitorAbout">
    <div class="header">
      <div class="service_h">联系我们</div>
    </div>
    <div class="content">
      <p>
        <span>公司名称：</span>
        {{ cName }}
      </p>
      <p>
        <span>联&nbsp;&nbsp;系&nbsp;&nbsp;人：</span>
        {{ pName }}
      </p>
       <p>
        <span>联系电话：</span>
        {{ mobile }}
      </p>
       <p>
        <span>地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址：</span>
        {{ cAddress }}
      </p>
       <p>
        <span>公司网址：</span>
        {{ cWebsite }}
      </p>
       <p>
        <span>电子邮件：</span>
        {{ pEmail }}
      </p>
    </div>
    <div class="message_div">
      <el-button @click="messClick">在线留言</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["exhibitorId"],
  data() {
    return {
      cName: "",
      pName: "",
      mobile: "",
      cAddress: "",
      cWebsite: "",
      pEmail: ""
    };
  },
  mounted() {
    let sessionAccountId = sessionStorage.getItem("accountId");
    this.init(sessionAccountId);
  },
  methods: {
    // 资讯详情
    init(id) {
      this.$http({
        url: "getAccountIndex",
        method: "post",
        params: {
          accountId: id
        }
      }).then( ({data}) => {
        let { code, user } = data;
        if (code === 0) {
          this.cName = user.cName;
          this.pName = user.pName;
          this.mobile = user.mobile;
          this.cAddress = user.cAddress;
          this.cWebsite = user.cWebsite;
          this.pEmail = user.pEmail;
        }
      })
    },


    messClick() {
      this.$router.push({
        path: "/exhibitorHome/mess"
      })
    }
  }
};
</script>>
<style lang="scss" scoped>
.exhibitorAbout {
  width: 100%;
  height: 1161px;
  background-color: #ffffff;
  color: #333333;
  .header {
    width: 100%;
    height: 30px;
    line-height: 35px;
    margin-bottom: 55px;
    .service_h {
      width: 100px;
      height: 100%;
      float: left;
      font-size: 16px;
      color: #143372;
      border-top: 2px solid #143372;
      border-right: 1px solid #bbbbbb;
      text-align: center;
    }
  }
  .content {
    width: 838px;
    margin-left: 42px;
    font-size: 18px;
    color: #333333;
    p {
      line-height: 60px;
      span {
        margin-right: 39px;
      }
    }
  }
  .message_div {
    width: 400px;
    height: 60px;
    margin: 65px auto 0;
  }
  .el-button {
    color: #ffffff;
    width: 100%;
    height: 100%;
    background-color: #ff6600;
    &:focus {
      border-color: #ff6600;
    }
  }
}
</style>